import { kioskRuntime } from './runtime-config';

export const storage = {
  get<T>(key: string, fallback: T): T {
    try { return JSON.parse(localStorage.getItem(kioskRuntime.storageKey(key)) ?? '') as T; } catch { return fallback; }
  },
  set(key: string, value: unknown) {
    try { localStorage.setItem(kioskRuntime.storageKey(key), JSON.stringify(value)); return true; }
    catch { return false; }
  },
};
